import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import {
  ILegalTransactionRelationship,
  initLegalTransactionRelationshipSkeleton,
} from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import {
  IMemberInheritor,
  InheritorMemberSchema,
} from '../../Members/IMemberInheritor';
import { getEmptyInheritanceProvisionRelationshipData } from './ILegalTransactionRelationshipInheritanceProvisionData';

export const InheritanceProvisionRelationshipSchema =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.InheritanceProvision),
    z.literal(2).optional(),
    z.object({
      provisionNotes: z.string(),
    }),
    InheritorMemberSchema
  );

export type IInheritanceProvisionRelationship = Omit<
  z.infer<typeof InheritanceProvisionRelationshipSchema>,
  'Members'
> & {
  Members: IMemberInheritor[];
};

export function isInheritanceProvisionRelationship(
  relationship: ILegalTransactionRelationship | undefined
): relationship is IInheritanceProvisionRelationship {
  return (
    relationship?.idRelationshipType ===
    LegalTransactionRelationshipTypeEnum.InheritanceProvision
  );
}

export function getEmptyInheritanceProvisionRelationship(): IInheritanceProvisionRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType:
      LegalTransactionRelationshipTypeEnum.InheritanceProvision,
    data: getEmptyInheritanceProvisionRelationshipData(),
    Members: [],
  };
}
